import React from 'react';
import CommonGrid from './CommonGrid';
import { ColumnType } from '../../../../components/Grid/constants';
import Button from "../../../../components/form/Button";
import {styles} from "../../index";
import {ReleasedType, WorkingPositionHandoverProtocolType} from "../../enum";
import Check from "material-ui/svg-icons/navigation/check";
import Close from "material-ui/svg-icons/navigation/close";

const releasedMapper = (value) => {
  if (value === 'RELEASED') return 'Uvolněný';
  if (value === 'NOT_RELEASED') return 'Neuvolněný';
  return value || '';
};

const BulkImportRecordsGrid = (props) => {
  const columns = [
    {
      field: 'state',
      label: 'Stav',
      type: ColumnType.JSX,
      jsx: (row) => {
        const style = row.imported ? { color: 'green' } : { color: '#df2424' };
        if (row.imported) {
          return <Check style={style}/>;
        } else {
          return <Close style={style} />;
        }
      }
    },
    {
      field: 'note',
      label: 'Poznámka',
      type: ColumnType.JSX,
      width: '25%',
      jsx: (row) => {
        const style = row.imported ? { color: 'green' } : { color: '#df2424' };
        return (
            <div className="cro__bulkImportRecordsNote">
              <span style={style}>{row.note}</span>
            </div>
        );
      }
    },
    {
      field: 'titleBefore',
      label: 'Titul před',
      type: ColumnType.TEXT,
      width: '5%',
    },
    {
      field: 'firstName',
      label: 'Jméno',
      type: ColumnType.TEXT,
      width: '7%',
    },
    {
      field: 'middleName',
      label: 'Další jména',
      type: ColumnType.TEXT,
      width: '7%',
    },
    {
      field: 'lastName',
      label: 'Příjmení',
      type: ColumnType.TEXT,
      width: '7%',
    },
    {
      field: 'titleAfter',
      label: 'Titul za',
      type: ColumnType.TEXT,
      width: '5%',
    },
    {
      field: 'birthDate',
      label: 'Datum narození',
      type: ColumnType.DATE,
      width: '7%',
    },
    {
      field: 'birthCountry',
      label: 'Stát narození',
      type: ColumnType.TEXT,
      width: '7%',
    },
    {
      field: 'birthMunicipality',
      label: 'Obec narození',
      type: ColumnType.TEXT,
      width: '7%',
    },
    {
      field: 'email',
      label: 'Email',
      type: ColumnType.TEXT,
      width: '8%',
    },
    {
      field: 'workingPosition',
      label: 'Funkce',
      type: ColumnType.TEXT,
      width: '7%',
    },
    {
      field: 'released',
      label: 'Uvolněnost',
      type: ColumnType.ENUM,
      enum: ReleasedType,
      displayField: 'released',
      mapper: releasedMapper,
      exportValue: (row) => releasedMapper(row.released),
      width: '6%',
    },
    {
      field: 'organization',
      label: 'Organizace',
      type: ColumnType.TEXT,
      width: '7%',
    },
    {
      field: 'start',
      label: 'Datum zahájení výkonu funkce',
      type: ColumnType.DATE,
      width: '6%',
    },
    {
      field: 'end',
      label: 'Datum ukončení výkonu funkce',
      type: ColumnType.DATE,
      width: '6%',
    },
    {
      field: 'dateOfStart',
      label: 'Datum předání informace o zápisu zahájení',
      type: ColumnType.DATE,
      width: '6%',
    },
    {
      field: 'dateOfEnd',
      label: 'Datum předání informace o zápisu ukončení',
      type: ColumnType.DATE,
      width: '6%',
    },
    {
      field: 'username',
      label: 'Přihlašovací jméno',
      type: ColumnType.TEXT,
      width: '7%',
    },
    {
      field: 'password',
      label: 'Heslo',
      type: ColumnType.TEXT,
      width: '7%',
    },
    {
      field: 'actions',
      label: 'Akce',
      type: ColumnType.JSX,
      width: '15%',
      jsx: (row) => {
        return (row.imported && row.workingPositionId &&
          <div className="cro__bulkImportRecordsActions">
            <Button
                type="button"
                style={{ ...styles.buttons }}
                label="Předávací protokol (vstupní)"
                onClick={() => props.handleHandoverProtocol(row.officialId, row.workingPositionId, WorkingPositionHandoverProtocolType.INGOING_STATEMENT)}
            />
            {row.end && (
                <Button
                    type="button"
                    style={{ ...styles.buttons }}
                    label="Předávací protokol (výstupní)"
                    onClick={() => props.handleHandoverProtocol(row.officialId, row.workingPositionId, WorkingPositionHandoverProtocolType.OUTGOING_STATEMENT)}
                />
            )}
          </div>
        );
      }
    }
  ];

  return <CommonGrid {...props} columns={columns} sort="created" />;
};

export default BulkImportRecordsGrid;
